export default {
  CONTENT_API: '//content.api.bobcat.com/',
  OP_API: '//op.api.bobcat.com/',
  ERP_API: '//erp.api.bobcat.com/',
  CUSTOMER_API: '//customer-contact.api.bobcat.com/',
  ACCOUNTS_API: '//accounts.api.bobcat.com/',
  SUBSCRIPTIONS_API: '//subscriptions.api.bobcat.com/',
  IAM_API: '//iam.api.bobcat.com/',
  SALESFORCE_NA: '//www.bobcatdealernet.com/',
  SALESFORCE_EMEA: '//hub.bobcat.eu/',
  DPMM_API: '//dpmm.api.bobcat.com/',
  MAGNOLIA_AUTHOR: '//magnolia-cms.dibhids.net/',
  MAGNOLIA_PUBLIC: '//magnolia-public.dibhids.net/',
  NGPASSPORT_API: '//adminenigma.api.dibhids.net/',
  SERVICE_AI: '//service-ai-v2-session-api.ai.bobcat.com/',
  AGENT_AI: '//bedrock-agentcore.us-east-1.amazonaws.com/runtimes/serviceaiv2chat-E79o6hD9qB/invocations?accountId=831926586418&qualifier=stable'
}
